import { render } from "./PassCode.vue?vue&type=template&id=77a64024"
import script from "./PassCode.vue?vue&type=script&lang=js"
export * from "./PassCode.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__